import { grey } from "@mui/material/colors";

const styles = {
  brandListContainer: {
    overflowY: "scroll",
    flexGrow: 1,
    paddingBottom: "20px", // To leave space for the "Bento reloads message"
  },
  explanation: {
    backgroundColor: "secondary.light",
    borderTop: `1px solid ${grey[200]}`,
    padding: 1,
    marginBottom: { xs: 10, md: 0 },
  },
  subtitle: {
    p: 2,
    color: grey[600],
    fontStyle: "italic",
  },
  tab: {
    color: "black",
    textTransform: "none",
    fontSize: 12,
  },
  link: {
    textDecoration: "none",
    fontSize: 12,
    cursor: "pointer",
    fontWeight: "bold",
  },
  refreshButton: {
    mb: 1,
    textTransform: "none",
    borderBottom: `2px solid`,
    borderColor: "primary.main",
    borderRadius: 0,
    display: "block",
  },
};

export default styles;
